/**
 * Notification Model for V2 Services
 */

export type NotificationType =
  | 'booking_created'
  | 'booking_scheduled'
  | 'booking_completed'
  | 'booking_cancelled'
  | 'payment_received'
  | 'payment_failed'
  | 'robot_assigned'
  | 'robot_maintenance'
  | 'system_alert'
  | 'user_message';

export type NotificationPriority = 'low' | 'medium' | 'high' | 'urgent';

export interface NotificationData {
  id?: string;
  userId?: string;
  type: NotificationType;
  title: string;
  message: string;
  priority: NotificationPriority;
  read: boolean;
  actionUrl?: string;
  metadata?: Record<string, any>;
  createdAt: Date;
  readAt?: Date;
}

export class Notification {
  public id?: string;
  public userId?: string;
  public type: NotificationType;
  public title: string;
  public message: string;
  public priority: NotificationPriority;
  public read: boolean;
  public actionUrl?: string;
  public metadata: Record<string, any>;
  public createdAt: Date;
  public readAt?: Date;

  constructor(data: Partial<NotificationData>) {
    this.id = data.id;
    this.userId = data.userId;
    this.type = data.type || 'system_alert';
    this.title = data.title || '';
    this.message = data.message || '';
    this.priority = data.priority || 'medium';
    this.read = data.read || false;
    this.actionUrl = data.actionUrl;
    this.metadata = data.metadata || {};
    this.createdAt = data.createdAt || new Date();
    this.readAt = data.readAt;
  }

  public toFirestore(): Record<string, any> {
    return {
      userId: this.userId,
      type: this.type,
      title: this.title,
      message: this.message,
      priority: this.priority,
      read: this.read,
      actionUrl: this.actionUrl,
      metadata: this.metadata,
      createdAt: this.createdAt,
      readAt: this.readAt
    };
  }

  public static fromFirestore(data: any): Notification {
    return new Notification({
      ...data,
      createdAt: data.createdAt?.toDate?.() || data.createdAt,
      readAt: data.readAt?.toDate?.() || data.readAt
    });
  }

  public markAsRead(): void {
    this.read = true;
    this.readAt = new Date();
  }

  public markAsUnread(): void {
    this.read = false;
    this.readAt = undefined;
  }
}